import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import baseStyles from '../../base/outline-element/outline-element.base.css.lit';
import utilityStyles from '../../base/outline-element/outline-element.utilities.css.lit';
import baseHeadingStyles from '../../base/outline-heading/outline-heading.css.lit';
import headingStyles from '../idb-heading/idb-heading.css.lit';
import componentStyles from './idb-styled-text.css.lit';
import { OutlineStyledText } from '../../base/outline-styled-text/outline-styled-text';
import { classMap } from 'lit/directives/class-map.js';

type Narrow = 'fluid' | 'sm' | 'md' | 'lg';

/**
 * The IDB Styled Text component
 * @element idb-styled-text
 * @slot - default slot supplied by idb-styled-text
 */
@customElement('idb-styled-text')
export class IdbStyledText extends OutlineStyledText {
  static styles: CSSResultGroup = [
    baseStyles, // Styles from outline-element. Primarily to include @tailwind base;
    utilityStyles, // Styles from outline-element. Primarily to include @tailwind utilities;
    baseHeadingStyles, // Styles from outline-heading.
    headingStyles, // Styles from idb-heading, a specific component we want to represent in the WYSIWYG.
    componentStyles, // Styles specific to idb-styled-text.
  ];

  @property({ type: String, attribute: 'narrow' })
  narrow: Narrow = 'fluid';

  @property({ type: Boolean, attribute: 'line-clamp' })
  lineClamp: false;

  @property({ type: String, attribute: 'color' })
  color: string;

  render(): TemplateResult {
    const blockClasses = {
      [`narrow--${this.narrow}`]: true,
      'line-clamp': this.lineClamp,
      [`idb-color--${this.color}`]:true ,
    };

    return html`
      <div class=${classMap(blockClasses)}>
        <slot></slot>
      </div>
    `;
  }
}
